import { BaseError } from 'make-error'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const NAME = `ResourceNotFoundError`
const MESSAGE = `Resource was not found`

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

class ResourceNotFoundError extends BaseError {
  constructor(slug) {
    super(MESSAGE)
    this.name = NAME
    this.slug = slug
  }
}

export default ResourceNotFoundError
